import { useAtom } from 'jotai';
import { useEffect, useState } from 'react';
import MainLayout from '../../layouts/MainLayout';
import { assistantNcRequestAtom } from '../../stores/assistant-nc-request.store';
import { AssistantShellFrame } from './assistant-shell-frame';

/**
 * Route shell for every self-check page (CCP calendars, records, exports and
 * entity histories): renders the standard layout plus the assistant FAB and
 * panel, so pages stay untouched and the chat is available on the whole
 * `/self-check/*` surface.
 */
export function SelfCheckAssistantShell() {
  const [assistantOpen, setAssistantOpen] = useState(false);
  // "Gestisci con l'assistente AI" sulle sezioni NC: la sezione scrive la
  // richiesta nello store (è annidata nelle card, lontano dal pannello), la
  // shell apre il pannello e gli passa il messaggio da inviare; consumata la
  // richiesta viene azzerata così una riapertura manuale non la rigioca.
  const [ncRequest, setNcRequest] = useAtom(assistantNcRequestAtom);
  useEffect(() => {
    if (ncRequest) {
      setAssistantOpen(true);
    }
  }, [ncRequest]);

  return (
    <>
      <MainLayout />
      <AssistantShellFrame
        autoSend={ncRequest ? { message: ncRequest.message, token: ncRequest.nonce } : undefined}
        onAutoSendConsumed={() => setNcRequest(null)}
        onOpenChange={setAssistantOpen}
        open={assistantOpen}
      />
    </>
  );
}
